var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.479 19.1202C25.1934 19.1202 29.0152 15.2984 29.0152 10.584C29.0152 5.86963 25.1934 2.04785 20.479 2.04785C15.7646 2.04785 11.9428 5.86963 11.9428 10.584C11.9428 15.2984 15.7646 19.1202 20.479 19.1202Z",
    fill: "#769DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 32.3693C38.5 35.6012 30.4223 39.5453 20.4791 39.5453C10.536 39.5453 2.45837 35.2543 2.45837 32.3693C2.45837 28.3888 10.536 22.4729 20.4791 22.4729C30.4223 22.4729 38.5 28.3888 38.5 32.3693Z",
    fill: "#769DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPerson);
export default __webpack_public_path__ + "static/media/ic_person.8bd5aa6f02a35a37ad91581d143f4be3.svg";
export { ForwardRef as ReactComponent };